import { Button, Checkbox, FormControlLabel } from "@material-ui/core";
import React, { useState } from "react";

export default function IntegrityAgreement(props) {
  const [isChecked, setIsChecked] = useState(false);
  const { modal_action } = props;

  const handleAgree = () => {
    if (modal_action && typeof modal_action === "function") modal_action();
  };

  return (
    <>
      <div
        className="modal-agreement"
        style={{ maxHeight: "60vh", overflowY: "auto" }}
      >
        <div>
          <p>
            <strong>Dengan ini saya menyatakan bahwa:</strong>
          </p>

          <ol style={{ textAlign: "left", lineHeight: 1.8 }}>
            <li>
              Saya akan mengerjakan tes secara{" "}
              <strong>mandiri dan jujur</strong>, tanpa bantuan pihak lain.
            </li>
            <li>
              Saya <strong>tidak akan menggunakan</strong> buku, catatan,
              internet, mesin pencari, aplikasi AI, atau sumber referensi apa
              pun selama tes berlangsung.
            </li>
            <li>
              Saya <strong>tidak akan merekam</strong>, memfoto, menyalin, atau
              menyebarluaskan materi tes dalam bentuk apa pun.
            </li>
            <li>
              Saya akan <strong>mematuhi</strong> seluruh instruksi, tata
              tertib, dan batas waktu yang telah ditentukan.
            </li>
            <li>
              Saya akan memastikan <strong>kamera perangkat tetap aktif</strong>{" "}
              dan <strong>tidak ditutup/dihalangi</strong> selama tes
              berlangsung, sehingga sistem dapat melakukan pengambilan gambar
              secara berkala untuk tujuan <strong>pengawasan</strong> dan
              menjaga <strong>integritas pelaksanaan tes</strong>.
            </li>
            <li>
              Saya <strong>tidak akan berpindah</strong> dari halaman tes
              (misalnya membuka tab/aplikasi lain atau meminimalkan layar)
              selama tes berlangsung. Saya memahami bahwa apabila sistem
              mendeteksi perpindahan halaman sebanyak{" "}
              <strong>3 (tiga) kali</strong>, maka tes akan langsung{" "}
              <strong>tersubmit secara otomatis</strong>.
            </li>
            <li>
              Saya memahami bahwa <strong>pelanggaran</strong> terhadap
              ketentuan ini dapat mengakibatkan{" "}
              <strong>pembatalan hasil tes</strong> dan/atau{" "}
              <strong>diskualifikasi</strong> dari proses assessment sesuai{" "}
              <strong>kebijakan yang berlaku</strong>.
            </li>
          </ol>

          <p style={{ marginTop: 30, fontStyle: "italic", color: "#666" }}>
            Dengan mencentang kotak persetujuan di bawah ini, saya menyatakan
            telah membaca, memahami, dan menyetujui seluruh ketentuan di atas.
          </p>
        </div>
      </div>

      <div
        style={{
          padding: "20px 0",
          borderTop: "1px solid #e0e0e0",
          textAlign: "center",
          marginTop: 20,
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
              color="primary"
            />
          }
          label="Saya menyetujui Pakta Integritas dan siap memulai tes"
          style={{ marginBottom: 15 }}
        />
        <br />
        <Button
          onClick={handleAgree}
          disabled={!isChecked}
          variant="contained"
          color="primary"
          size="medium"
          style={{
            textTransform: "none",
            borderRadius: 8,
            fontWeight: "bold",
            minWidth: 200,
            padding: "12px 30px",
          }}
        >
          Setuju
        </Button>
      </div>
    </>
  );
}
